import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { FeaturedAppCard } from '../components/AppCard/FeaturedAppCard';
import { mockApps } from '../utils/mockData';
export const FeaturedApps = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gray-50" data-id="element-1569">
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10" data-id="element-1570">
        <div className="max-w-7xl mx-auto px-4 py-4" data-id="element-1571">
          <div className="flex items-center" data-id="element-1572">
            <button onClick={() => navigate(-1)} className="mr-4 text-gray-500 hover:text-gray-700" data-id="element-1573">
              <ArrowLeftIcon className="h-5 w-5" data-id="element-1574" />
            </button>
            <div data-id="element-1575">
              <h1 className="text-xl font-semibold" data-id="element-1576">Featured Apps</h1>
              <p className="text-sm text-gray-500" data-id="element-1577">
                Discover our curated selection of top AI apps
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-6" data-id="element-1578">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1579">
          {mockApps.map(app => <FeaturedAppCard key={app.id} id={app.id} icon={app.icon} iconBg={app.iconBg} title={app.title} author={app.author} description={app.description} rating={app.rating} reviews={app.reviews} data-id="element-1580" />)}
        </div>
      </div>
    </div>;
};